import Layout from "@/views/layout/library/index";

const teamWork = [
    {
        path: "/product/detail/:isDetail/:id",
        name: '产品详情',
        menuName: '产品详情',
        component: () => import("@/views/psa/teamWork/productManage/index"),
    },
    {
        path: "/document/detail/:isDetail/:id",
        name: '文档详情',
        menuName: '文档详情',
        component: () => import("@/views/psa/teamWork/documentManage/index"),
    },
]


export default teamWork;
